export default function isOuterAreaClick(target, event) {
  const rect = target.getBoundingClientRect();
  if (rect.left > event.clientX || rect.top > event.clientY || rect.right < event.clientX || rect.bottom < event.clientY) {
    return true;
  } else {
    return false;
  }
}